// Country codes with flag emojis — kept in sync with /app/frontend/src/components/PhoneInput.jsx
const COUNTRY_CODES = [
  { code: "+60", flag: "🇲🇾" },
  { code: "+65", flag: "🇸🇬" },
  { code: "+62", flag: "🇮🇩" },
  { code: "+66", flag: "🇹🇭" },
  { code: "+63", flag: "🇵🇭" },
  { code: "+84", flag: "🇻🇳" },
  { code: "+673", flag: "🇧🇳" },
  { code: "+95", flag: "🇲🇲" },
  { code: "+856", flag: "🇱🇦" },
  { code: "+855", flag: "🇰🇭" },
  { code: "+1", flag: "🇺🇸" },
  { code: "+44", flag: "🇬🇧" },
  { code: "+61", flag: "🇦🇺" },
  { code: "+91", flag: "🇮🇳" },
  { code: "+86", flag: "🇨🇳" },
  { code: "+81", flag: "🇯🇵" },
  { code: "+82", flag: "🇰🇷" },
  { code: "+971", flag: "🇦🇪" },
  { code: "+966", flag: "🇸🇦" },
  { code: "+49", flag: "🇩🇪" },
  { code: "+33", flag: "🇫🇷" },
];

// Longest-prefix first so e.g. +673 matches before +6
const SORTED = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);

/**
 * Returns the flag emoji for a phone number whose country code is identifiable.
 * Returns null when the phone has no leading "+" or the prefix doesn't match a known code.
 */
export function getCountryFlag(phone) {
  if (!phone) return null;
  const cleaned = String(phone).replace(/\s/g, "");
  if (!cleaned.startsWith("+")) return null;
  for (const c of SORTED) {
    if (cleaned.startsWith(c.code)) return c.flag;
  }
  return null;
}
